import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ConfirmImportedErpOrderNFeInput } from './ConfirmImportedErpOrderNFeInput';
import { ConfirmImportedErpOrderNFeOutput } from './ConfirmImportedErpOrderNFeOutput';

export class ConfirmImportedErpOrderNFeService extends HttpServiceBase {

  handle = (input: ConfirmImportedErpOrderNFeInput): Promise<Result<ConfirmImportedErpOrderNFeOutput> | null> => {
    const promise = this.http.post<Result<ConfirmImportedErpOrderNFeOutput>, ConfirmImportedErpOrderNFeInput>(
      `${this.baseUrlSislogApi}/v2/order/${input.orderId}/erp-order-nfe/imported`,
      input
    );
    return promise;
  }
}
